import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, mergeMap, map, exhaustMap, tap, finalize } from 'rxjs/operators';

import { of } from 'rxjs';
import {
    updateRecord,
    updateRecordSuccess,
    updateRecordFailure,
    fetchSingleRecord,
    fetchSingleRecordSuccess,
    fetchSingleRecordFail,
    fetchBulkMembers,
    fetchBulkMembersSuccess,
    fetchBulkMembersFail,
    fetchBulkHistory,
    fetchBulkHistorySuccess,
    fetchBulkHistoryFail
} from './bulk-tools.action';
import { AlertService } from 'src/app/core/services/alert.service';
import { CrudServerService } from 'src/app/core/services/crud-server.service';
import { RouterService } from 'src/app/core/services/router.service';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { DatatableService } from 'src/app/core/services/datatable.service';
import { BulkToolTableService } from './bulk-tools-table.service';
import { BulkHistoryTableService } from './bulk-history-table.service';
import { HelperService } from 'src/app/core/services/helper.service';

@Injectable()
export class BulkToolsRecordEffects {

    fetchSingle$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleRecord),
            exhaustMap(() => {
                const url = 'bulk-tools';
                return this.crudServerService.fetchData(url).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        const data = response.data;
                        return fetchSingleRecordSuccess({singleData: data.record});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                // this.routeService.triggerRoute(null, "/bulk-tools");
                            }),
                            map(() => fetchSingleRecordFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    updateData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateRecord),
            exhaustMap((data:any) => {
                const url = 'bulk-tools/';
                return this.crudServerService.updateDataPost(url, data.updatedData).pipe(
                    map( (response) => {
                        this.alertService.triggerAlert(response.message, "success");
                        return updateRecordSuccess();
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                            }),
                            map(() => updateRecordFailure({ error })) // Dispatch 
                        )
                    ),

                    finalize(() => {
                        this.helperService.formButtonDisabled = false;
                    })
                )
            })
        )
    );

    fetchBulkMembers$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchBulkMembers),
            exhaustMap((data) => {
                const url = 'bulk-users/'+this.moduleTableService.actionId;
                return this.crudServerService.fetchTableData(url, this.moduleTableService).pipe(
                    map( (response) => {

                        const responseData = response.data;

                        this.moduleTableService.page = responseData.pagination.current_page;
                        this.moduleTableService.lastPage = responseData.pagination.last_page;
                        this.moduleTableService.pagination = this.tableService.getPaginationArray(responseData.pagination.current_page, responseData.pagination.last_page);

                        this.moduleTableService.clubs = responseData.clubs;

                        this.alertService.triggerAlert(response.message, "success");
                        const data = response.data;
                        return fetchBulkMembersSuccess({members: data.records, total: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                // this.routeService.triggerRoute(null, "/bulk-tools");
                            }),
                            map(() => fetchBulkMembersFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    fetchBulkHistory$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchBulkHistory),
            exhaustMap(() => {
                const url = 'bulk-history';
                return this.crudServerService.fetchTableData(url, this.moduleHistoryTableService).pipe(
                    map( (response) => {

                        const responseData = response.data;

                        this.moduleHistoryTableService.page = responseData.pagination.current_page;
                        this.moduleHistoryTableService.lastPage = responseData.pagination.last_page;
                        this.moduleHistoryTableService.pagination = this.tableService.getPaginationArray(responseData.pagination.current_page, responseData.pagination.last_page);

                        this.alertService.triggerAlert(response.message, "success");
                        const data = response.data;
                        return fetchBulkHistorySuccess({bulkItems: data.records, total: data.pagination.total});
                    }),
                    
                    catchError((error) =>
                        of(error).pipe(
                            tap(() => {
                                this.alertService.triggerAlert(error, "error");
                                // this.routeService.triggerRoute(null, "/bulk-tools");
                            }),
                            map(() => fetchBulkHistoryFail({ error })) // Dispatch 
                        )
                    )
                )
            })
        )
    );

    constructor(
        private actions$: Actions,
        private crudServerService: CrudServerService,
        private alertService: AlertService,
        private routeService: RouterService,
        private moduleTableService: BulkToolTableService,
        private moduleHistoryTableService: BulkHistoryTableService,
        private store: Store<RootReducerState>,
        private tableService: DatatableService,
        public helperService: HelperService
    ) { }

}